import React from 'react';
import SearchItem from './SearchItem';
import SuggestedList from './SuggestedList';

const SearchList = ({ data, onGetSuggestion, itemQuery }) => {
    let content = <SuggestedList onGetSuggestion={onGetSuggestion} />;

    if (data.length > 0) {
        content = (
            <div className="search-list__row">
                <div className="search-list__wrapper">
                    {data.map((item) => (
                        <SearchItem
                            key={`result-${item.rank}`}
                            item={item}
                            itemQuery={itemQuery}
                        />
                    ))}
                </div>
            </div>
        );
    }

    return <>{content}</>;
};

export default SearchList;
